import { NgModule } from '@angular/core';
import { LICENSE_LAYOUT_CONFIG, licenseLayoutConfiguration } from './gridster.config';

@NgModule({
  providers: [{ provide: LICENSE_LAYOUT_CONFIG, useValue: licenseLayoutConfiguration }],
})
export class ConfigurationModule {}
